import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, BookOpenIcon, UsersIcon, GlobeIcon, ShieldCheckIcon, LandmarkIcon } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function WhatThisMakesPossible() {
  const {
    t,
    tArray
  } = useLanguage();
  const featuresData = tArray<{
    title: string;
    desc: string;
  }>('whatThisMakesPossible.features');
  const icons = [<HeartIcon className="w-8 h-8" strokeWidth={1.5} data-id="element-186" />, <BookOpenIcon className="w-8 h-8" strokeWidth={1.5} data-id="element-187" />, <UsersIcon className="w-8 h-8" strokeWidth={1.5} data-id="element-188" />, <GlobeIcon className="w-8 h-8" strokeWidth={1.5} data-id="element-189" />, <ShieldCheckIcon className="w-8 h-8" strokeWidth={1.5} data-id="element-190" />, <LandmarkIcon className="w-8 h-8" strokeWidth={1.5} data-id="element-191" />];
  const features = featuresData.map((f, i) => ({
    ...f,
    icon: icons[i % icons.length]
  }));
  return <section className="py-24 md:py-32 bg-ivory" data-id="element-192">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-194">
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-4" data-id="element-195">
            {t('whatThisMakesPossible.title1')}{' '}
            <span className="text-saffron italic" data-id="element-196">
              {t('whatThisMakesPossible.title2')}
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-197">
          {features.map((feature, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-marble p-8 rounded-sm border border-gold/10 hover:border-gold/30 transition-colors shadow-sm hover:shadow-md flex flex-col items-start" data-id="element-198">
              <div className="text-saffron mb-6 bg-ivory p-4 rounded-full shadow-sm" data-id="element-199">
                {feature.icon}
              </div>
              <h3 className="font-heading text-2xl text-navy mb-3" data-id="element-200">
                {feature.title}
              </h3>
              <p className="text-navy/70 leading-relaxed" data-id="element-201">{feature.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}